import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { AddBlogDTO } from "./AddBlog";

type AddBlogResponse  = AddBlogDTO & ApiError;

export const EditBlog = (data: AddBlogDTO, id:string): Promise<AddBlogResponse> => {
    return axios.patch(`/blog/${id}`, data)
        .then(response => response.data as AddBlogResponse);
};